import React from 'react';
import { AlertCircle } from 'lucide-react';

const OutOfService = () => {
  return (
    <div className="min-h-screen bg-mesh-soft text-slate-700">
      <div className="mx-auto flex min-h-screen w-full max-w-6xl items-center px-4 py-10 sm:px-6 lg:px-8">
        <section className="w-full rounded-[2rem] border border-slate-200/80 bg-white/90 p-8 backdrop-blur-sm sm:p-10">
          <div className="inline-flex items-center gap-2 rounded-full border border-[var(--color-primary)]/10 bg-[var(--color-primary-soft)] px-3 py-1 text-xs font-semibold uppercase tracking-[0.22em] text-[var(--color-primary)]">
            <AlertCircle className="h-3.5 w-3.5" />
            Service Update
          </div>

          <h1 className="mt-6 max-w-2xl text-4xl font-bold leading-tight text-slate-900 font-heading sm:text-5xl">
            This site is temporarily unavailable.
          </h1>

          <p className="mt-4 max-w-2xl text-base leading-7 text-slate-600">
            server is broken on 11 may 10.10 Am, the issue will fix soon
          </p>
        </section>
      </div>
    </div>
  );
};

export default OutOfService;
